import React, { Component } from 'react';
import './styles.css';
import classNames from 'classnames';

/**
 * HowQrWorks Component
 *
 * @typedef {Object} Card
 * @prop {Object} image - Image object
 * @prop {string} image.src - Image source path
 * @prop {string} image.alt - Image alt text
 * @prop {string} title - Card title
 * @prop {string} content - Card content description
 *
 * @typedef {Object} Props
 * @prop {Card[]} cards - Array of card objects to display
 * @prop {string} className - CSS class name
 * @prop {string} heading - Main heading text
 * @prop {string} subHeading - Main heading text
 *
 * @augments {Component<Props>}
 */
export default class HowQrWorks extends Component {

	genClassName = (className) => classNames('HowQrWorks', className);

	genTextBlock = (cards) =>
		cards.map((card, idx) => {
			// eslint-disable-next-line react/no-array-index-key
			return (<div className='Column' key={idx}>
				<div className='cardWrapper'>
					<div className={'infoBlock'}>
						<h2>{card.title}</h2>
						<p className={'cardContent'}>{card.content}</p>
					</div>
					<picture className='cardPicture'>
						<img src={require(`../../../assets/images/${card.image.src}`)} alt={card.image.alt} />
					</picture>
				</div>
			</div>);
		});

	render () {
		const { cards, heading, subHeading, className } = this.props;

		return (
			<section className={this.genClassName(className)}>
				{heading ? <h1>{heading}</h1> : ''}
				{subHeading ? <h2 className='subHeading'>{subHeading}</h2> : ''}
				<div className='HowQrWorks-container'>
					<div className='Row'>{this.genTextBlock(cards)}</div>
				</div>
			</section>
		);
	}
}




// WEBPACK FOOTER //
// ./src/components/templates/HowQrWorks/HowQrWorks.js